// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M3,11.0926554 C3.16050331,11.1113072 3.32382311,11.120849 3.48941073,11.120849
				C4.4506017,11.120849 5.33523538,10.7979728 6.03738249,10.256317 C5.1396174,
				10.2400058 4.38194521,9.65611357 4.12088957,8.85372989 C4.2461319,8.87731459
				4.37466623,8.8899531 4.50685833,8.8899531 C4.69399027,8.8899531 4.87523318,
				8.86528819 5.04740481,8.81912701 C4.1088189,8.63361809 3.40166063,7.81733565
				3.40166063,6.83880492 C3.40166063, 6.83030723 3.40166063,6.82184555 3.40180694,
				6.81341987 C3.67844471,6.96468597 3.99476938,7.05553205 4.33110209,7.06601014
				C3.78060646,6.70385007 3.41837668, 6.08567905 3.41837668,5.38501562 C3.41837668,
				5.01489796 3.51955082,4.66796893 3.69614836,4.36968557 C4.70803614,5.59155272
				6.21975932,6.39559272 7.92486923, 6.47981348 C7.88990087,6.33200407 7.87172172,
				6.17785739 7.87172172,6.01956989 C7.87172172,4.90424795 8.79033615,4 9.92340612,
				4 C10.5134789,4 11.0466733,4.24528081 11.4209371,4.63779492 C11.8882549,4.54720089
				12.3273346,4.37911944 12.723728,4.14770139 C12.5705403,4.61928724 12.245254,5.015078
				11.8216467,5.26503974 C12.2366583,5.21621403 12.6320641,5.10765242 13,4.94702446
				C12.7249351,5.35203305 12.3770804,5.70774784 11.976261, 5.99249251 C11.9802114,
				6.07908974 11.9821866,6.16619107 11.9821866,6.2537605 C11.9821866,8.92257559
				9.91861443,12 6.14495775,12 C4.98635649,12 3.90793372,11.6656735 3,11.0926554 Z"
			/>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Twitter.js